import { Modal } from '~/components/modal';
import {
  IGetPricing,
  ILeaseLookup,
  IPaymentEstimate,
} from '~/interfaces/commerce-types';
import ProgressiveLeaseFound from './progressive-lease-found';
//import { IShoppingCart } from "~/types/buy-types";
//import { CartCheckoutConfigs } from "~/services/apis/brightspot/get-cart-configs";
import { ProgressiveConfiguration } from '~/gql/__generated__/types';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';

interface IProgressivePaymentModalProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  paymentEstimate?: IPaymentEstimate;
  leaseDetails: ILeaseLookup;
  total: number;
  checkoutCart: ISalesOrderResponse;
  progressiveOrderReview: (pricingInfo: IGetPricing) => void;
  progressiveConfigs: ProgressiveConfiguration;
  cartId: string;
}
const ProgressiveLeaseModal: React.FC<IProgressivePaymentModalProps> = ({
  isModalOpen,
  toggleModal,
  paymentEstimate,
  leaseDetails,
  total,
  checkoutCart,
  progressiveOrderReview,
  progressiveConfigs,
  cartId,
}) => {
  const modalBody = paymentEstimate && (
    <ProgressiveLeaseFound
      leaseDetails={leaseDetails}
      paymentEstimate={paymentEstimate}
      total={total}
      toggleModal={toggleModal}
      checkoutCart={checkoutCart}
      progressiveOrderReview={progressiveOrderReview}
      progressiveConfigs={progressiveConfigs}
      cartId={cartId}
    />
  );
  return (
    <Modal
      headerTitle="Progressive Leasing"
      modalBody={modalBody}
      isOpen={isModalOpen}
      toggleModal={toggleModal}
    />
  );
};

export default ProgressiveLeaseModal;
